import React from "react";
import classNames from "classnames";
import { DraggingTooltip } from "./DraggingTooltip";
import styles from "./DragCardHover.module.scss";

interface DragCardHoverProps {
    className?: string;
    isDragging: boolean;
    accessoryId?: string;
    frameId?: string;
    isClickActive?: boolean;
}

export const DragCardHover = ({ className = '', isDragging, accessoryId, frameId, isClickActive}: DragCardHoverProps) => {

    const HoverClassNames = classNames(`${styles.overlay} ${className}`, {
        [styles.isClickedActive]: isClickActive,
        [styles.isDragged]: isDragging
    });

    return (
        <div className={ HoverClassNames } draggable="false">
            <DraggingTooltip accessoryId={accessoryId} frameId={frameId} isClickActive={isClickActive} />
        </div>
    );
};